import React from 'react';
import styled from 'styled-components';

const Home = () => (
  <Container>
    <h1>Robins</h1>
  </Container>
);

export default Home;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
`;
